// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1lnxs","row":"Node_row__1BQt4","label":"Node_label__3eaN_","footer":"Node_footer__1DzD0"};